import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TipoCategoriaService } from './shared/tipo-categoria.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CategoriaService } from './shared/categoria.service';
import 'datatables.net';
import 'datatables.net-bs4';
import * as $ from 'jquery';
import { TipoCategoria } from './shared/tipo-categoria.model';
import { Categoria } from './shared/categoria.model';

@Component({
  selector: 'app-categorias',
  templateUrl: './categorias.component.html',
  styleUrls: ['./categorias.component.css']
})
export class CategoriasComponent implements OnInit {
  datatableInfCat: any;
  datatableCat: any;

  ListCategorias: TipoCategoria[] = [];
  ListCategoriasByTipo: Categoria[] = [];
  formCategoria: FormGroup;
  formTipoCategoria: FormGroup;
  edit: boolean;
  editing: boolean;
  btnAtras: boolean;
  frameCategoria: boolean;
  editCategoria: boolean;
  editTipoCategoria: boolean;

  constructor(
    private toastr: ToastrService,
    public tipoCategoriaService: TipoCategoriaService,
    private categoriaService: CategoriaService,
    private _fb: FormBuilder,
    private chRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.refreshListTipoCat();
    this.initForm();
  }

  initForm() {
    this.formCategoria = this._fb.group({
      idAdmCategoria: 0,
      idAdmTipoCategoria: 0,
      nombreCat: [""],
      codigo: [""],
      nombre: [""],
      descripcion: [""]
    });

    this.formTipoCategoria = this._fb.group({
      idAdmTipoCategoria: [0],
      nombre: [""],
      activo: [true]
    });
  }

  refreshListTipoCat() {
    this.tipoCategoriaService.getTipoCa().then(r => {

      if ($.fn.dataTable.isDataTable('#datatableInfCat')) {
        this.datatableInfCat.destroy();
      }

      this.ListCategorias = r as TipoCategoria[];

      this.chRef.detectChanges();

      const table: any = $('#datatableInfCat');
      this.datatableInfCat = table.DataTable({
        responsive: true
      })

    });
    //this.tipoCategoriaService.getTipoCa();
  }

  listCategorias(id: number, nombreTipoCategoria: string) {
    this.btnAtras = true;
    this.edit = true;
    this.frameCategoria = true;
    this.formCategoria.patchValue({
      idAdmTipoCategoria: id,
      nombreCat: nombreTipoCategoria
    });
    this.getCategoriaByIdTipo(id)
    //this.categoriaService.getCategoriaByIdTipo(id);
  }

  getCategoriaByIdTipo(id: number) {
    this.categoriaService.getCategoriaByIdTipo(id).then(r => {

      if ($.fn.dataTable.isDataTable('#datatableCat')) {
        this.datatableCat.destroy();
      }

      this.ListCategoriasByTipo = r as Categoria[];

      this.chRef.detectChanges();

      const table: any = $('#datatableCat');
      this.datatableCat = table.DataTable({
        responsive: true
      })

    });
  }

  onSubmitCategoria() {
    this.insertCategoria();
  }

  cancelState() {
    this.btnAtras = false;
    this.frameCategoria = false;
    this.edit = false;
    this.formCategoria.reset();
    this.formTipoCategoria.reset();
    this.refreshListTipoCat();
  }

  insertCategoria() {
    let nombre = this.formCategoria.get("nombreCat").value;
    let id = this.formCategoria.get("idAdmTipoCategoria").value;
    this.categoriaService.postCategoria(this.formCategoria.value).then(r => { this.toastr.success("Exito"); this.formCategoria.reset; this.listCategorias(id, nombre) });
  }

  editarTipoCategoria(nombre: string, id: number) {
    this.editTipoCategoria = true;
    this.frameCategoria = false;
    this.edit = false;
    this.formTipoCategoria.patchValue({
      idAdmTipoCategoria: id,
      nombre: nombre
    });
  }

  editarCategoria(nombre: string, id: number) {
    this.editCategoria = true;
    this.formCategoria.patchValue({
      idAdmCategoria: id,
      nombre: nombre
    });
  }

  updateCategoria() {
    this.editCategoria = false;
    let id = this.formCategoria.get("idAdmCategoria").value;
    let tipo = this.formCategoria.get("idAdmTipoCategoria").value;
    let nombreTipo = this.formCategoria.get("nombreCat").value;
    this.categoriaService.putCategoria(this.formCategoria.value, id).then(r => { this.toastr.success("Exito!"); this.listCategorias(tipo, nombreTipo) })
    this.formCategoria.patchValue({ nombre: '' });
  }

  updateTipoCategoria() {
    this.editTipoCategoria = false;
    let id = this.formTipoCategoria.get("idAdmTipoCategoria").value;
    this.tipoCategoriaService.putTipoCat(this.formTipoCategoria.value, id).then(r => { this.toastr.success("Exito"); this.refreshListTipoCat(); this.formTipoCategoria.reset });
  }


  deleteCategoria(id: number) {
    this.categoriaService.deleteCategoria(id).then(r => {
      this.frameCategoria = false;
      this.refreshListTipoCat();
      this.toastr.error('Eliminado correctamente');
    });
  }
}

